import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const UpcomingEvents = () => {
  const navigate = useNavigate();
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await axios.get('/api/events');
        if (response.data.status === 'success') {
          setUpcomingEvents(response.data.data.upcoming);
        } else {
          setError('Failed to fetch events');
        }
      } catch (err) {
        console.error("Error fetching events:", err);
        setError('Error connecting to server');
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  // Helper to format date
  const formatDateRange = (from, to) => {
    const options = { day: 'numeric', month: 'short', year: 'numeric' };
    const fromDate = new Date(from).toLocaleDateString('en-GB', options);
    const toDate = new Date(to).toLocaleDateString('en-GB', options);
    return `${fromDate} to ${toDate}`;
  };

  return (
    <>
      <div className="breadcumb-wrapper" style={{ backgroundImage: `url('assets/img/hero/slider1.jpg')`, backgroundPosition: 'center', backgroundSize: 'cover' }}>
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Updates & Announcements</h1>
          </div>
        </div>
      </div>

      <ul className="nav nav-tabs d-flex justify-content-center pt-5 pb-5">
        <li className="nav-item">
          <span className="nav-link" style={{cursor: 'pointer'}} onClick={() => navigate('/events')}>Past Events</span>
        </li>
        <li className="nav-item">
          <span className="nav-link active" style={{cursor: 'pointer'}} onClick={() => navigate('/upcoming-events')}>Updates & Announcements</span>
        </li>
      </ul>

      <section className="bg-theme overflow-hidden space" data-bg-src="assets/img/bg/event-shape.html">
        <div className="container">
          <div className="title-area style3 text-center">
            <span className="sub-title style text-anime-style-2" style={{ color: '#840000' }}>
              Upcoming Events
            </span>
            <h2 className="sec-title text-white text-anime-style-3">Our Programs</h2>
          </div>

          {loading ? (
            <div className="text-center text-white">Loading...</div>
          ) : error ? (
            <div className="text-center text-white">{error}</div>
          ) : upcomingEvents.length === 0 ? (
            <div className="text-center text-white">No upcoming events found.</div>
          ) : (
            <div className="row gy-4 gx-40">
              {upcomingEvents.map((event, index) => (
                <div key={event._id} className="col-12">
                  <div className="event-box wow fadeInUp" data-wow-delay=".1s">
                    <div className="box-img global-img">
                      <img
                        src={event.image ? `${event.image}` : "/web/assets/img/event/event1.jpg"}
                        alt={event.title}
                        style={{ width: '100%', height: 'auto', maxHeight: '400px', objectFit: 'cover' }}
                      />
                    </div>
                    <div className="box-wrapper">
                      <div className="box-wrapp">
                        <div className="num">
                          <h2 className="box-number">{String(index + 1).padStart(2, '0')}</h2>
                        </div>
                        <div className="box-content">
                          <h3 className="box-title">
                            <a href="#">{event.title}</a>
                          </h3>
                          <div className="event-meta">
                            <a href="#">
                              <i className="fa-solid fa-calendar-days"></i>
                              {formatDateRange(event.fromDate, event.toDate)}
                            </a>
                          </div>
                          <p className="box-text">
                            {event.message}
                          </p>
                        </div>
                      </div>
                      {(event.pdfFile || event.externalLink) && (
                        <div className="">
                          <a 
                            href={event.pdfFile ? (window.location.hostname === 'localhost' && window.location.port !== '8000' ? `http://localhost:8000${event.pdfFile}` : event.pdfFile) : event.externalLink} 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className="th-btn th-icon"
                          >
                            <span className="btn-text">Know More</span>
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default UpcomingEvents;
